<template>
    <van-popup
    v-model="actionSheetShow"
    :round="round"
    position="bottom"
    >
      <slot></slot>
    </van-popup>
</template>

<script>
export default {
  props: {
    round: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionSheetShow: false
    }
  },
  methods: {
    change () {
      this.actionSheetShow = !this.actionSheetShow
    }
  }
}
</script>

<style lang="less" scoped>
</style>
